var slideWrapper = $(".hero"),
    iframes = slideWrapper.find('.embed-player'),
    lazyImages = slideWrapper.find('.slide-image'),
    lazyCounter = 0;

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command) {
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
}

// When the slide is changing
function playPauseVideo(slick, control) {
    var currentSlide, slideType, startTime, player, video;

    currentSlide = slick.find(".slick-active");
    slideType = currentSlide.attr("class").split(" ")[1];
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");

    if (slideType === "vimeo") {
        switch (control) {
            case "play":
                if ((startTime != null && startTime > 0) && !currentSlide.hasClass('started')) {
                    currentSlide.addClass('started');
                    postMessageToPlayer(player, {
                        "method": "setCurrentTime",
                        "value": startTime
                    });
                }
                postMessageToPlayer(player, {
                    "method": "play",
                    "value": 1
                });
                break;
            case "pause":
                postMessageToPlayer(player, {
                    "method": "pause",
                    "value": 1
                });
                break;
        }
    } else if (slideType === "youtube") {
        switch (control) {
            case "play":
                postMessageToPlayer(player, {
                    "event": "command",
                    "func": "mute"
                });
                postMessageToPlayer(player, {
                    "event": "command",
                    "func": "playVideo"
                });
                break;
            case "pause":
                postMessageToPlayer(player, {
                    "event": "command",
                    "func": "pauseVideo"
                });
                break;
        }
    } else if (slideType === "video") {
        video = currentSlide.children("video").get(0);
        if (video != null) {
            if (control === "play") {
                video.play();
            } else {
                video.pause();
            }
        }
    }
}

// Resize player
function resizePlayer(iframes, ratio) {
    if (!iframes[0]) return;
    var win = $(".hero"),
        width = win.width(),
        playerWidth,
        height = win.height(),
        playerHeight,
        ratio = ratio || 16 / 9;

    iframes.each(function() {
        var current = $(this);
        if (width / ratio < height) {
            playerWidth = Math.ceil(height * ratio);
            current.width(playerWidth).height(height).css({
                left: (width - playerWidth) / 2,
                top: 0
            });
        } else {
            playerHeight = Math.ceil(width / ratio);
            current.width(width).height(playerHeight).css({
                left: 0,
                top: (height - playerHeight) / 2
            });
        }
    });
}

// DOM Ready
$(function() {
    // Initialize
    slideWrapper.on("init", function(slick) {
        slick = $(slick.currentTarget);
        setTimeout(function() {
            playPauseVideo(slick, "play");
        }, 1000);
        resizePlayer(iframes, 16 / 9);
    });
    slideWrapper.on("beforeChange", function(event, slick) {
        slick = $(slick.$slider);
        playPauseVideo(slick, "pause");
    });
    slideWrapper.on("afterChange", function(event, slick) {
        slick = $(slick.$slider);
        playPauseVideo(slick, "play");
    });
    slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
        lazyCounter++;
        if (lazyCounter === lazyImages.length) {
            lazyImages.addClass('show');
            slideWrapper.slick("slickPlay");
        }
    });
    slideWrapper.slick({
        fade: true,
        autoplaySpeed: 2000,
        pauseOnHover: true,
        pauseOnFocus: false,
        lazyLoad: "progressive",
        speed: 900,
        infinite: true,
        autoplay: true,
        arrows: false,
        dots: true,
        cssEase: "cubic-bezier(0.87, 0.03, 0.41, 0.9)"
    });
    $('.pub-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.pub-gallery-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.pub-gallery',
        dots: false,
        arrows: true,
        centerMode: false,
        focusOnSelect: true
    });
    $(window).on("scroll", function(event) {
        scrollTop = $(window).scrollTop();
        if (scrollTop >= 100) {
            $('#floating-smartbar').addClass('fixed-smartbar');
        } else {
            $('#floating-smartbar').removeClass('fixed-smartbar');
        }
    });
    $('.wired-media-tabs').each(function(i, el) {
        var tabheading = $(this).find(".tab-heading");
        var wiredmediatabs = $(this).find(".wp-block-group__inner-container").first();
        $(tabheading.get().reverse()).each(function(i, el2) {
            wiredmediatabs.prepend(el2);
        });

        $(this).find(".tab-heading").first().addClass("active");
        $(this).find(".wired-tab-block").first().addClass("active");

    });
    $(".tab-heading").on("click", function(event) {
        var parenttabs = $(this).closest(".wired-media-tabs");
        parenttabs.find(".wired-tab-block").removeClass("active");
        parenttabs.find(".tab-heading").removeClass("active");
        var tab_heading = $(this);
        var tabblock = parenttabs.find(".wired-tab-block");
        var activetabIndex = parenttabs.find(".tab-heading");
        //setTimeout(function() {
        tab_heading.addClass("active");
        $(activetabIndex).each(function(i, el) {
            if ($(this).hasClass("active")) {
                $(tabblock).each(function(a, el) {
                    if (a == i) {
                        $(this).addClass("active")
                    }
                });
            }

        });
        //}, 50);

    });

    createMobile();
    formPosition();
    $(window).on("resize", formPosition);
});

function checkSubmit() {
    $('.form-wrapper .wpcf7-form-control.wpcf7-submit').each(function(k,v){
        var height = $(v).innerHeight();
        $(v).css("backgroundSize", height);
    });
}

function createMobile() {
    var form = $('.form-wrapper');
    if(form.length > 0) {
        var mobileForm = form.clone();
        $(mobileForm).addClass("mobile");
        $(mobileForm).addClass("wp-block-group");
        $(mobileForm).addClass("alignfull");
        $(mobileForm).addClass("has-theme-white-background-color");
        $(mobileForm).addClass("has-background");
        $('main#site-content > article.page > div.post-inner > div.entry-content').children().eq(0).after(mobileForm);
    }
}
function checkMobile() {
    var form = $('.form-wrapper').eq(0);
    if(form.length > 0) {
        var mobileForm = $('.form-wrapper.mobile');
        var winW = window.innerWidth;
        if(winW < 900){
            $(mobileForm).show();
            $(form).hide();
            return true;
        }else{
            $(mobileForm).hide();
            $(form).show();
            return false;
        }
    }
}


function formPosition(){
    checkSubmit();
    var form = $('.form-wrapper').eq(0);
    if(form.length > 0){
        var isMobile = checkMobile();
        if(isMobile){
            return;
        }
        var formW = $(form).width();
        var formH = $(form).height();
        var headerH = $('.header-inner.section-inner').height();
        var slider = $(".hero-wrap.full-width");
        var totalW = $(slider).width();
        var totalH = $(slider).height();
        totalH -= headerH;
        totalH -= formH;
        var top = Math.round(totalH / 2);
        var halfW = Math.round(totalW / 2);
        halfW -= formW;
        var right = Math.round(halfW / 2);
        var winW = window.innerWidth;
        if(winW >= 1000){
            top += 100;
        }
        $(form).css("top", top+"px");
        $(form).css("right", right+"px");
    }
}


// Resize event
$(window).on("resize.slickVideoPlayer", function() {
    resizePlayer(iframes, 16 / 9);
});

var slideIndex = 1;
showSlide(slideIndex);

// Next/previous controls
function plusSlides(n) {
    showSlide(slideIndex += n);
}

// Thumbnail image controls
function currentSlide(n) {
    showSlide(slideIndex = n);
}

function showSlide(n) {
    var i;
    var slides = document.querySelectorAll(".testimonials_slides_wrapper > div");
    var dots = document.getElementsByClassName("dot");
    if(dots.length === 0){
        init_dots();
    }
    if (n > slides.length) {slideIndex = 1}
    if (n < 1) {slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[slideIndex-1].style.display = "block";
    dots[slideIndex-1].className += " active";
}

function init_dots(){
    var slides = document.querySelectorAll('.testimonials_slides_wrapper > div');
    var dot_space = document.getElementsByClassName("dot_space")[0];
    for(var i = 0; i < slides.length; i++){
        var idx = i + 1;
        var str = '<span class="dot" onClick="currentSlide('+idx+')"></span>';
        var dateSpan = document.createElement('span');
        dateSpan.className = "dot";
        dateSpan.setAttribute("idx", idx);
        dateSpan.onclick = function(){
            var idx = this.getAttribute("idx");
            currentSlide(idx);
        };
        dot_space.appendChild(dateSpan);
    }

}


function showSlides() {
    var i;
    var slides = document.querySelectorAll(".testimonials_slides_wrapper > div");
    var dots = document.getElementsByClassName("dot");
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
    slideIndex++;
    if (slideIndex > slides.length) {slideIndex = 1}
    slides[slideIndex-1].style.display = "block";
    dots[slideIndex-1].className += " active";

    setTimeout(showSlides, 5000); // Change image every 2 seconds
}

setTimeout(showSlides, 5000); // Change image every 2 seconds
